import type { AppDispatch } from '@/store/types'
import pushyme from '@/services/Pushyme/Pushyme'
import { setUser } from '@/store/user/user'
import { clear as clearChats, setActiveChatId } from '@/store/chats/chats'
import { clear as clearScroll } from '@/store/scroll/scroll'
import { set as setMessages } from '@/store/messages/messages'
import { setTab } from '@/store/navTab/navTab'
import { Tabs } from '@/store/navTab/constants'
import { setActiveService } from '@/store/services/services'
import { setActiveNews } from '@/store/news/news'
import { resetTabs } from '@/store/settings/settings'

/**
 * Clears the current session synchronously: drops the push token and resets the
 * auth/chat/service state. Dispatching `clearChats()` lets the cache middleware
 * wipe the IndexedDB caches. Route guards react to `setUser(null)` and redirect,
 * so no navigation is triggered here.
 */
export const clearSession = (dispatch: AppDispatch) => {
  pushyme.removeToken()
  dispatch(setUser(null))
  dispatch(clearChats())
  dispatch(clearScroll())
  dispatch(setMessages({ messages: {} }))
  dispatch(setTab(Tabs.Chats))
  dispatch(setActiveService(null))
  dispatch(setActiveChatId(null))
  dispatch(setActiveNews(null))
  dispatch(resetTabs(null))
}
